module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8n3n6n-ac06ee9bf549960306dc711fb30f2b6c.svg";